import React, { Component, useState, useEffect } from "react";

import { MDBContainer } from "mdbreact";
import { Card, CardBody, CardHeader } from "reactstrap";
import { Container, Typography, Grid } from "@material-ui/core";
import BreadCumb from "../Department/BreadCumb";
import { PostData } from "../../api/service";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

export default class FormerOfficer extends Component {
  state = {
    data: [],
    isLoaded: false,
  };

  componentDidMount() {
    PostData(`/getemployeebytype`, {
        dept_code: "NSS",
        type:"FORMER_PROGRAM_OFFICER"
    }).then((resp) => {
      this.setState({
        data: resp,
        isLoaded: true,
      });
    });
  }

  render() {
    return (
      <div>
        <BreadCrumbOwn title="Former Programme Officer" />

        <Container className="mb-5">
          <br />

          <div>
            <Typography
              variant="h5"
              style={{ margin: "1em 0", fontWeight: 700 }}
              gutterBottom
            >
              Former Programme Officer
            </Typography>

            <br />

            <div>
              {this.state.isLoaded && (
                <>
                  <Grid container spacing={2}>
                    {this.state.data.map((el, index) => (
                      <Grid item xs={12} sm={12} md={6} lg={6} key={index}>
                        <Card>
                          <CardBody
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              {Array.isArray(el.dp) &&
                                el.dp.map((el1) => (
                                  <img src={el1} style={{ width: 150 }} />
                                ))}
                            </div>
                            <div
                              style={{
                                paddingLeft: 20,
                                display: "flex",
                                justifyContent: "center",
                                flexDirection: "column",
                              }}
                            >
                              <Typography
                                variant="h6"
                                style={{ fontWeight: 700 }}
                                gutterBottom
                              >
                                {el.name}
                              </Typography>
                              <Typography variant="overline">
                                DESIGNATION
                              </Typography>
                              <Typography
                                variant="body2"
                                style={{ fontWeight: 700 }}
                                gutterBottom
                              >
                                {el.designation}
                              </Typography>
                              <br />
                              <Typography variant="overline">
                                CONTACT
                              </Typography>
                              <Typography variant="body1">
                                <a href={`mailto:${el.email.toLowerCase()}`}>
                                  {el.email.toLowerCase()}
                                </a>
                              </Typography>
                            </div>
                          </CardBody>
                        </Card>
                        <br />
                      </Grid>
                    ))}
                  </Grid>
                </>
              )}
            </div>
          </div>
        </Container>
      </div>
    );
  }
}
